import React from "react";

export default function HR() {
  return (
    <div className="page">
      <h1>HR Solutions</h1>
      <p>Overview of HR services.</p>
    </div>
  );
}
